import React, { FC } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import ButtonBase from '@mui/material/ButtonBase'
import Check from '@mui/icons-material/Check'
import Alert from '@mui/material/Alert'

export const PREDEFINED_COLORS = [
  '#CC9816', // Gold/Orange
  '#C2185B', // Deep Pink
  '#9C27B0', // Purple
  '#673AB7', // Deep Purple
  '#31805B', // Green
  '#0B707B', // Teal
  '#11539D', // Blue
  '#621B0E', // Brown
]

interface ColorSelectorProps {
  value: string | null
  onChange: (color: string) => void
  error?: string
}

export const ColorSelector: FC<ColorSelectorProps> = ({
  value,
  onChange,
  error,
}) => {
  return (
    <Box>
      <Typography variant="subtitle3">Select Color*</Typography>
      {error && (
        <Alert severity="error" sx={{ mt: 1 }}>
          {error}
        </Alert>
      )}
      <Box
        sx={{
          mt: 1,
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 1,
        }}
      >
        {PREDEFINED_COLORS.map((color) => (
          <ButtonBase
            key={color}
            onClick={() => onChange(color)}
            sx={{
              width: '100%',
              height: 48,
              backgroundColor: color,
              borderRadius: '4px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              border: value === color ? '2px solid #fff' : 'none',
              boxShadow: value === color ? '0 0 0 2px #0D47A1' : 'none',
              transition: 'transform 0.1s',
              '&:hover': {
                transform: 'scale(1.05)',
              },
            }}
          >
            {value === color && (
              <Check
                sx={{ color: '#fff', fontSize: 20 }}
                data-test-id={`knockStatusColorSelectedIcon-${color}`}
              />
            )}
          </ButtonBase>
        ))}
      </Box>
    </Box>
  )
}
